import { useState } from 'react';
import { IStrongBoxFilter } from '@nkr/models/strong-box';
import { Utility } from '@nkr/services/utility';
import useStrongBoxPhysicalInventory from '@nkr/store/strong-box/hooks/use-strong-box-physical-inventory';
import StrongBoxFilter from './strong-box-filter';
import PhysicalInventoryGrid from './physical-inventory-grid';

const PhysicalInventory = () => {
    const defaultFilter: IStrongBoxFilter = {
        startDate: Utility.getFirstOfCurrentMonth(),
        endDate: Utility.getLastOfCurrentMonth()
    }

    const [filter, setFilter] = useState<IStrongBoxFilter>(defaultFilter);
    const { list, loading, error, update } = useStrongBoxPhysicalInventory(() => {}, filter);

    return (
        <PhysicalInventoryGrid
            list={list}
            loading={loading}
            error={error}
            csvFileName='StrongBoxPhysicalInventory.csv'
            filterSlot={
                <StrongBoxFilter
                    filter={filter} 
                    defaultFilter={defaultFilter}
                    startDateLabel='Earliest Report Date'
                    endDateLabel='Latest Report Date'
                    isCenter={true}
                    onChange={setFilter}
                />
            }
            isCenter={true}
            onUpdate={update}
        />
    );
}

export default PhysicalInventory;
